const TYPE = '@type';
export const getWidgetDataResponseType = widgetData => widgetData === null || widgetData === void 0 ? void 0 : widgetData[TYPE];